<av-content-container>
  <div class="col-6 mb-4 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.connected_devices.sections.usb_devices.title'" icon="usb"
      [columns]="usbDeviceColumns" [rows]="usbDeviceRows()"
      [countLabelKey]="'app.device.connected_devices.count.usb_devices_found_suffix'"
      [emptyTextKey]="'app.device.connected_devices.empty.usb_devices'" [pageSize]="5" [trackByKey]="'deviceId'" />
  </div>

  <div class="col-6 mb-4 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.connected_devices.sections.monitors.title'" icon="desktop_windows"
      [columns]="monitorColumns" [rows]="monitorRows()"
      [countLabelKey]="'app.device.connected_devices.count.monitors_found_suffix'"
      [emptyTextKey]="'app.device.connected_devices.empty.monitors'" [pageSize]="5" [trackByKey]="'monitorId'" [truncateAfter]="30" />
  </div>

  <div class="col-12 d-flex align-items-stretch">
    <av-table-card [titleKey]="'app.device.connected_devices.sections.bluetooth_devices.title'" icon="bluetooth"
      [columns]="bluetoothColumns" [rows]="bluetoothRows()"
      [countLabelKey]="'app.device.connected_devices.count.bluetooth_devices_found_suffix'"
      [emptyTextKey]="'app.device.connected_devices.empty.bluetooth_devices'" [pageSize]="5" [truncateAfter]="40"
      [trackByKey]="'deviceId'" />
  </div>
</av-content-container>